export default "__VITE_ASSET__mg7Lzkch__ 1233w, __VITE_ASSET__w3AIUP96__ 1233w, __VITE_ASSET__$toWS_B8__ 1233w, __VITE_ASSET__AUEho1Xe__ 1233w";